import { Box } from '@chakra-ui/react';
import { formatDataTestId } from '../../utils/formatters';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Section(_ref) {
  var children = _ref.children,
    dataTestId = _ref.dataTestId;
  return _jsx(Box, {
    as: "section",
    "data-testid": formatDataTestId(dataTestId, 'Section'),
    borderBottom: "1px solid var(--chakra-colors-lightGrey4)",
    children: children
  });
}